function initializeCarouselForArticlePictures() {
  const track = document.querySelector(".carouselTrack");
  if (!track) return;

  const slides = Array.from(track.children);
  if (slides.length === 0) return;

  const prevButton = document.querySelector(".prevButton");
  const nextButton = document.querySelector(".nextButton");

  // ボタンが存在しない場合は処理を中断
  if (!prevButton || !nextButton) return;

  const slideWidth = slides[0].getBoundingClientRect().width;

  // 各スライドを正しい位置に配置
  const setSlidePosition = (slide, index) => {
    slide.style.left = `${slideWidth * index}px`;
  };
  slides.forEach(setSlidePosition);

  // ボタンの表示/非表示を更新
  const updateButtonsVisibility = (currentSlide) => {
    prevButton.classList.toggle(
      "isHidden",
      !currentSlide.previousElementSibling
    );
    nextButton.classList.toggle("isHidden", !currentSlide.nextElementSibling);
  };

  // スライドを移動する関数
  const moveSlide = (currentSlide, targetSlide) => {
    track.style.transform = `translateX(-${targetSlide.style.left})`;
    currentSlide.classList.remove("currentPosition");
    targetSlide.classList.add("currentPosition");
    updateButtonsVisibility(targetSlide);
  };

  // 初期状態の設定
  slides[0].classList.add("currentPosition");
  updateButtonsVisibility(slides[0]);

  // 前へボタンのクリックイベント
  prevButton.addEventListener("click", () => {
    const currentSlide = track.querySelector(".currentPosition");
    const prevSlide = currentSlide.previousElementSibling;
    if (prevSlide) {
      moveSlide(currentSlide, prevSlide);
    }
  });

  // 次へボタンのクリックイベント
  nextButton.addEventListener("click", () => {
    const currentSlide = track.querySelector(".currentPosition");
    const nextSlide = currentSlide.nextElementSibling;
    if (nextSlide) {
      moveSlide(currentSlide, nextSlide);
    }
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeCarouselForArticlePictures;